module.exports = __webpack_public_path__ + "img/web.37454d4b.png";